import React from "react";
import { ToastLinkProps } from "./Toast.types";
import { Link as StyledLink } from "./Link.styles";

/**
 * Button.Link styled to fit on the Toast layout
 */
export const Link = ({ children, className, ...props }: ToastLinkProps) => {
  return (
    <StyledLink className={className} {...props}>
      {children}
    </StyledLink>
  );
};
